import { DropdownWithLabel } from '@blueprint/dropdown';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
    DropdownWrapper,
    FiltersLabel,
    LeftWrapper,
    RightWrapper
} from './Options.styles';

const FilterWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin: 0;
        width: 100%;
        padding-bottom: ${spacing['24px']};
    `
);

const beds = ['', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

const bedsOptions = [
    { value: '0', text: 'Studio' },
    { value: '1', text: '1' },
    { value: '2', text: '2' },
    { value: '3', text: '3' },
    { value: '4', text: '4' },
    { value: '5', text: '5' },
    { value: '6', text: '6' },
    { value: '7', text: '7' },
    { value: '8', text: '8' },
    { value: '9', text: '9' },
    { value: '10', text: '10+' }
];

export type BedsMin = typeof beds[number];
export type BedsMax = typeof beds[number];

type SelectBedsProps = {
    value: {
        bedsMin: BedsMin;
        bedsMax: BedsMax;
    };
    onChange: ({
        bedsMin,
        bedsMax
    }: {
        bedsMin: BedsMin;
        bedsMax: BedsMax;
    }) => void;
};

export const SelectBeds = ({ value, onChange }: SelectBedsProps) => {
    const bedroomsLabel = 'Bedrooms';
    const minBedsLabel = 'Min beds';
    const maxBedsLabel = 'Max beds';

    const bedsMinOptions =
        value.bedsMax !== ''
            ? bedsOptions.slice(0, Number(value.bedsMax) + 1)
            : bedsOptions;

    const bedsMaxOptions =
        value.bedsMin !== ''
            ? bedsOptions.slice(Number(value.bedsMin))
            : bedsOptions;

    return (
        <FilterWrapper>
            <FiltersLabel htmlFor="modal-beds-filter">
                {bedroomsLabel}
            </FiltersLabel>
            <DropdownWrapper>
                <LeftWrapper>
                    <DropdownWithLabel
                        id="mobile_beds_min"
                        onChange={(e) => {
                            onChange({
                                ...value,
                                bedsMin: e.target.value
                            });
                        }}
                        value={value.bedsMin}
                        name="beds_min"
                        aria-label="Min Beds"
                        data-testid="min_beds_mobile"
                        label={minBedsLabel}
                        hasBorderRadius
                    >
                        <option value="">No min</option>
                        {bedsMinOptions.map((bedsMinOption, index) => {
                            return (
                                <option
                                    value={bedsMinOption.value}
                                    key={`modal_beds_mins_${index}`}
                                >
                                    {bedsMinOption.text}
                                </option>
                            );
                        })}
                    </DropdownWithLabel>
                </LeftWrapper>
                <RightWrapper>
                    <DropdownWithLabel
                        onChange={(e) => {
                            onChange({
                                ...value,
                                bedsMax: e.target.value
                            });
                        }}
                        value={value.bedsMax}
                        id="beds_max"
                        name="beds_max"
                        aria-label="Max Beds"
                        data-testid="max_beds_mobile"
                        label={maxBedsLabel}
                        hasBorderRadius
                    >
                        <option value="">No max</option>
                        {bedsMaxOptions.map((bedsMaxOption, index) => {
                            return (
                                <option
                                    value={bedsMaxOption.value}
                                    key={`modal_beds_max_${index}`}
                                >
                                    {bedsMaxOption.text}
                                </option>
                            );
                        })}
                    </DropdownWithLabel>
                </RightWrapper>
            </DropdownWrapper>
        </FilterWrapper>
    );
};
